import { isTDraft } from '@modules/items/types/items.types';

import type { TDocument, TDraft, TVersion } from '../types';
import getAiDisabledDocumentReason from './getAiDisabledDocumentReason.helper';

type TParams = {
  doc?: TDocument;
  version?: TVersion | TDraft;
  canEdit: boolean;
  isReplica?: boolean;
};

const isCurrentVersion = (doc: TDocument, version: TVersion | TDraft): boolean => {
  if (!isTDraft(version)) return !doc.draft && version.id === doc.versions[0]?.id;
  return Boolean(doc.draft);
};

const isAiEditDocumentEligible = ({ doc, version, canEdit, isReplica }: TParams): boolean => {
  if (!doc || !version) return false;

  return canEdit && !doc.isFrozen && !isReplica && !getAiDisabledDocumentReason(doc) && isCurrentVersion(doc, version);
};

export default isAiEditDocumentEligible;
